import * as React from "react";
const SVGComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 0 64 64" {...props}>
    <defs>
      <filter id="blur" x={-0.16995} y={-0.17864} width={1.3289} height={1.455}>
        <feGaussianBlur in="SourceAlpha" stdDeviation={3} />
        <feOffset dx={0} dy={0} result="offsetblur" />
        <feComponentTransfer>
          <feFuncA slope={0.05} type="linear" />
        </feComponentTransfer>
        <feMerge>
          <feMergeNode />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <style>
        {
          "@keyframes am-weather-cloud-1{0%,to{-webkit-transform:translate(-5px,0);-moz-transform:translate(-5px,0);-ms-transform:translate(-5px,0);transform:translate(-5px,0)}50%{-webkit-transform:translate(10px,0);-moz-transform:translate(10px,0);-ms-transform:translate(10px,0);transform:translate(10px,0)}}@keyframes am-weather-cloud-2{0%,to{-webkit-transform:translate(0,0);-moz-transform:translate(0,0);-ms-transform:translate(0,0);transform:translate(0,0)}50%{-webkit-transform:translate(2px,0);-moz-transform:translate(2px,0);-ms-transform:translate(2px,0);transform:translate(2px,0)}}@keyframes am-weather-stroke{0%,12%,16%,20%,24%,28%,4%,8%,to{-webkit-transform:translate(0,0);-moz-transform:translate(0,0);-ms-transform:translate(0,0);transform:translate(0,0)}10%,14%,18%,2%{-webkit-transform:translate(.3px,0);-moz-transform:translate(.3px,0);-ms-transform:translate(.3px,0);transform:translate(.3px,0)}6%{-webkit-transform:translate(.5px,.4px);-moz-transform:translate(.5px,.4px);-ms-transform:translate(.5px,.4px);transform:translate(.5px,.4px)}22%{-webkit-transform:translate(1px,0);-moz-transform:translate(1px,0);-ms-transform:translate(1px,0);transform:translate(1px,0)}26%{-webkit-transform:translate(-1px,0);-moz-transform:translate(-1px,0);-ms-transform:translate(-1px,0);transform:translate(-1px,0)}40%{fill:orange;-webkit-transform:translate(0,0);-moz-transform:translate(0,0);-ms-transform:translate(0,0);transform:translate(0,0)}65%{fill:#fff;-webkit-transform:translate(-1px,5px);-moz-transform:translate(-1px,5px);-ms-transform:translate(-1px,5px);transform:translate(-1px,5px)}61%{fill:orange}}@keyframes tornado{0%,to{-webkit-transform:translate(-5px,30px) scale(1);-moz-transform:translate(-5px,30px) scale(1);-ms-transform:translate(-5px,30px) scale(1);transform:translate(-5px,30px) scale(1)}33%{-webkit-transform:translate(-4px,30px) scale(1.1);-moz-transform:translate(-4px,30px) scale(1.1);-ms-transform:translate(-4px,30px) scale(1.1);transform:translate(-4px,30px) scale(1.1)}66%{-webkit-transform:translate(-6px,30px) scale(1.1);-moz-transform:translate(-6px,30px) scale(1.1);-ms-transform:translate(-6px,30px) scale(1.1);transform:translate(-6px,30px) scale(1.1)}}@keyframes error{0%,to{fill:#c00}50%{fill:red}}"
        }
      </style>
    </defs>
    <g id="thunder" transform="translate(-3.9995 -8)" filter="url(#blur)">
      <g transform="translate(20,5)">
        <g
          id="tornado"
          transform="translate(-5,30)"
          fill="#1d1d1d"
          stroke="#fff"
          style={{
            MozAnimationDuration: "3s",
            MozAnimationIterationCount: "infinite",
            MozAnimationName: "tornado",
            MozAnimationTimingFunction: "linear",
            WebkitAnimationDuration: "3s",
            WebkitAnimationIterationCount: "infinite",
            WebkitAnimationName: "tornado",
            WebkitAnimationTimingFunction: "linear",
            animationName: "tornado",
            animationDuration: "3s",
            animationTimingFunction: "linear",
            animationIterationCount: "infinite",
          }}
        >
          <path
            id="Polygon"
            d="m9.239 0h2.1597c1.403 0 2.7694 0.44812 3.9 1.279l0.07492 0.055065c0.84792 0.62321 1.0301 1.8158 0.40688 2.6637-0.06273 0.085346-0.13246 0.16531-0.20848 0.23907l-2.8266 2.7425c-1.0913 1.0589-1.8597 2.4058-2.2157 3.8841-0.35503 1.4743-1.1473 2.8068-2.2729 3.823l-3.1203 2.8168-1.9597 1.3737c-0.85678 0.60058-2.0382 0.3929-2.6388-0.46388-0.5411-0.77192-0.43235-1.8242 0.25517-2.4692l1.0781-0.9966c1.2556-1.1607 1.9695-2.793 1.9695-4.5029 0-1.7724-0.33249-3.529-0.98022-5.1788l-1.5105-3.8473c-0.20966-0.53401 0.053275-1.1369 0.58729-1.3465 0.12094-0.047481 0.24971-0.071854 0.37963-0.071854h6.922z"
          />
        </g>
        <g
          className="am-weather-cloud-1"
          style={{
            MozAnimationDuration: "7s",
            MozAnimationIterationCount: "infinite",
            MozAnimationName: "am-weather-cloud-1",
            MozAnimationTimingFunction: "linear",
            WebkitAnimationDuration: "7s",
            WebkitAnimationIterationCount: "infinite",
            WebkitAnimationName: "am-weather-cloud-1",
            WebkitAnimationTimingFunction: "linear",
            animationName: "am-weather-cloud-1",
            animationDuration: "7s",
            animationTimingFunction: "linear",
            animationIterationCount: "infinite",
          }}
        >
          <path
            transform="matrix(.6 0 0 .6 -10 -6)"
            d="m47.7 35.4c0-4.6-3.7-8.2-8.2-8.2-1 0-1.9 0.2-2.8 0.5-0.3-3.4-3.1-6.2-6.6-6.2-3.7 0-6.7 3-6.7 6.7 0 0.8 0.2 1.6 0.4 2.3-0.3-0.1-0.7-0.1-1-0.1-3.7 0-6.7 3-6.7 6.7 0 3.6 2.9 6.6 6.5 6.7h17.2c4.4-0.5 7.9-4 7.9-8.4z"
            fill="#666"
            stroke="#fff"
            strokeLinejoin="round"
            strokeWidth={1.2}
          />
        </g>
        <path
          transform="translate(-20,-11)"
          d="m47.7 35.4c0-4.6-3.7-8.2-8.2-8.2-1 0-1.9 0.2-2.8 0.5-0.3-3.4-3.1-6.2-6.6-6.2-3.7 0-6.7 3-6.7 6.7 0 0.8 0.2 1.6 0.4 2.3-0.3-0.1-0.7-0.1-1-0.1-3.7 0-6.7 3-6.7 6.7 0 3.6 2.9 6.6 6.5 6.7h17.2c4.4-0.5 7.9-4 7.9-8.4z"
          fill="#333"
          stroke="#fff"
          strokeLinejoin="round"
          strokeWidth={1.2}
        />
        <g
          className="am-weather-lightning"
          transform="matrix(1.2,0,0,1.2,-4,28)"
        >
          <polygon
            className="am-weather-stroke"
            style={{
              WebkitAnimationName: "am-weather-stroke",
              MozAnimationName: "am-weather-stroke",
              animationName: "am-weather-stroke",
              WebkitAnimationDuration: "1.11s",
              MozAnimationDuration: "1.11s",
              animationDuration: "1.11s",
              WebkitAnimationTimingFunction: "linear",
              MozAnimationTimingFunction: "linear",
              animationTimingFunction: "linear",
              WebkitAnimationIterationCount: "infinite",
              MozAnimationIterationCount: "infinite",
              animationIterationCount: "infinite",
            }}
            points="11.1 6.9 14.3 -2.9 20.5 -2.9 16.4 4.3 20.3 4.3 11.5 14.6 14.9 6.9"
            fill="#ffa500"
            stroke="#fff"
          />
        </g>
        <g id="error" transform="translate(20,30)">
          <path
            id="Shape"
            d="m7.7791 2.906-5.9912 10.117c-0.56283 0.95042-0.24862 2.1772 0.7018 2.74 0.30853 0.18271 0.66051 0.27911 1.0191 0.27911h11.982c1.1046 0 2-0.89543 2-2 0-0.35857-0.0964-0.71056-0.27911-1.0191l-5.9912-10.117c-0.56283-0.95042-1.7896-1.2646-2.74-0.7018-0.28918 0.17125-0.53055 0.41262-0.7018 0.7018z"
            fill="#c00"
            style={{
              MozAnimationDuration: "1s",
              MozAnimationIterationCount: "infinite",
              MozAnimationName: "error",
              MozAnimationTimingFunction: "linear",
              WebkitAnimationDuration: "1s",
              WebkitAnimationIterationCount: "infinite",
              WebkitAnimationName: "error",
              WebkitAnimationTimingFunction: "linear",
              animationName: "error",
              animationDuration: "1s",
              animationTimingFunction: "linear",
              animationIterationCount: "infinite",
            }}
          />
          <path
            id="Line"
            d="m9.5 10.5v-5"
            stroke="#fff"
            strokeLinecap="round"
            strokeWidth={1.5}
          />
          <circle id="Oval" cx={9.5} cy={13} r={1} fill="#fff" />
        </g>
      </g>
    </g>
  </svg>
);
export default SVGComponent;
